<template>
    <div class="profile-details-container">
        <div class="section-title">{{ $t('your profile details') | capitalize }}</div>
        <div class="data-row">
            <div class="data-field">
                <div class="label">{{ $t('username') | capitalize }} ({{ $t('display name') | capitalize }})</div>
                <div class="value">{{ user.username }}</div>
            </div>
        </div>
        <div class="data-row">
            <div class="data-field">
                <div class="label">{{ $t('phone') | capitalize }}</div>
                <div class="value">{{ user.phone }}</div>
            </div>
            <div class="data-field">
                <div class="label">{{ $t('E-mail') }}</div>
                <div class="value">{{ user.email }}</div>
            </div>
        </div>
        <SubtleLink :link= "{name: routeNames.settings }">
            {{ $t('edit profile information') | capitalize }}
        </SubtleLink>
        <SubtleLink :link= "{name: routeNames.passwordUpdate }">
            {{ $t('password update') | capitalize }}
        </SubtleLink>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';

    export default {
        name: 'ProfileDetails',
        props: {
            user: {
                type: Object,
                required: true,
            },
        },
        created() {
            this.routeNames = routeNames;
        },

    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/account/components/ProfileDetails.vue